import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@/core/services/open-api/user.service';
import { CurrentUser } from '@/core/models/user';
import { combineLatest, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AngularTranslations } from '@/core/types/angular-primeng-api';

@Component({
    selector: 'app-top-bar-controls',
    standalone: false,
    template: `
        <div class="flex items-center gap-1">
            <app-trial-top-bar class="mr-1" [style]="'display:inline-block'" />

            <a
                data-testid="topbar-help-link"
                class="top-bar-button right-sidebar-button"
                tabindex="0"
                routerLink="/help"
            >
                <i class="pi pi-question-circle"></i>
            </a>

            <a class="top-bar-button right-sidebar-button" tabindex="0" (click)="goToBuyBuzzer(0, false)">
                <i class="pi pi-shopping-cart"></i>
            </a>
        </div>
    `,
    styles: `
        a.top-bar-button {
            color: inherit;
            cursor: pointer;
        }
    `,
})
export class TopBarControlsComponent implements OnInit, OnDestroy {
    subscriptions = new Subscription();
    currentUser?: CurrentUser;

    constructor(
        private readonly translate: TranslateService,
        public readonly userService: UserService,
        public readonly router: Router,
    ) {}

    ngOnInit(): void {
        this.subscriptions.add(
            combineLatest([this.userService.currentUser$]).subscribe(([user]: [CurrentUser]) => {
                this.currentUser = user;
            }),
        );
        this.userService.loadCurrentUser().subscribe();
    }

    goToBuyBuzzer(buzzerQuantity: number, newTab: boolean): void {
        this.translate
            .get(['language_parameter_store_link', 'addons_hardware_woocommerce_product_id'])
            .subscribe((translations: AngularTranslations) => {
                this.userService.getLicensesURL().subscribe((data: string) => {
                    const storeLink = translations['language_parameter_store_link'];
                    const productId = translations['addons_hardware_woocommerce_product_id'];
                    const query = buzzerQuantity > 0 ? `add-to-cart=${productId}&quantity=${buzzerQuantity}&` : '';

                    const domain = data.split('?');
                    const newUrl = `${domain[0]}${storeLink}/cart?${query}${domain[1]}`;

                    const win = window.open(newUrl, newTab ? '_blank' : '_self');
                    if (!win || win.closed || typeof win.closed === 'undefined') {
                        console.log('Popup blocked');
                    }
                });
            });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
